import anime from 'animejs';

import {Component} from '@lib/Component';
import {sharedComponent} from '@lib/utils';
import {MediaQuery} from '@services/MediaQuery';

@sharedComponent
export class NavItem extends Component {
  mq = MediaQuery.create();
  isOpen = false;
  trigger: Component | null = null;
  content: Component | null = null;
  plus: HTMLDivElement | null = null;
  contentHeight = 0;

  getSize() {
    const clone = this.content?.element?.cloneNode(true) as HTMLElement;
    clone &&
      (clone.style.cssText =
        'visibility: hidden; position: static; display: inline-flex; flex-flow: column nowrap; margin: -9999px 0; height: auto; width: auto;');
    document.documentElement.appendChild(clone);
    const height = clone.clientHeight;
    const width = clone.clientWidth;
    document.documentElement.removeChild(clone);
    return {height, width};
  }

  getWidth() {
    const right = document.documentElement.querySelector('.o-nav_right');
    const width = right ? right.clientWidth : 0;
    return width / 2;
  }

  slideUp() {
    this.element?.classList.remove('open');
    this.plus?.classList.remove('open');

    if (this.mq.isPhone()) {
      anime({
        complete: () => {
          this.isOpen = false;
        },
        duration: 300,
        easing: 'easeOutCubic',
        height: 0,
        targets: this.content?.element,
      });
    } else {
      anime({
        complete: () => {
          this.isOpen = false;
        },
        delay: 100,
        duration: 400,
        easing: 'easeOutCubic',
        targets: this.content?.element,
        width: 0,
      });
    }
  }

  slideDown() {
    this.element?.classList.add('open');
    this.plus?.classList.add('open');
    if (this.mq.isPhone()) {
      const {height} = this.getSize();
      anime({
        complete: () => {
          this.isOpen = true;
        },
        duration: 300,
        easing: 'easeOutCubic',
        height,
        targets: this.content?.element,
      });
    } else {
      const {width} = this.getSize();
      // const width = this.getWidth();
      anime({
        complete: () => {
          this.isOpen = true;
        },
        duration: 600,
        easing: 'easeOutCubic',
        targets: this.content?.element,
        width,
      });
    }
  }

  didMount() {
    this.plus = this.element?.querySelector('.a-plus');

    const {trigger = '', content = ''} = this.element?.dataset || {};
    this.trigger = new Component();
    trigger &&
      this.trigger.mount(
        this.element?.querySelector(trigger) as HTMLDivElement,
      );
    this.content = new Component();
    content &&
      this.content.mount(
        this.element?.querySelector(content) as HTMLDivElement,
      );
    this.contentHeight = this.content?.element?.clientHeight ?? 0;

    this.trigger.on('click', () => {
      if (this.isOpen) {
        this.slideUp();
      } else {
        this.slideDown();
      }
    });

    this.content.on('click', () => {
      this.isOpen && this.slideUp();
    });
  }

  clearHandle() {
    this.trigger?.removeAllEventListeners('click');
  }
}
